import faceSmiling from '../../img/faceSmiling.jpg'
import face from '../../img/face.jpg'
import profile from '../../img/profile.jpg'
import leftSide from '../../img/leftSide.jpg'
import frontal from '../../img/frontal.jpg'
import rightSide from '../../img/rightSide.jpg'
import upperToothSector from '../../img/upperToothSector.jpg'
import bottomToothSector from '../../img/bottomToothSector.jpg'
import optionalPhoto from '../../img/optionalPhoto.jpg'

export const REDUCER_NAME = 'detail'

export const MAX_IMAGE_SIZE = 10 * 1024 * 1024

export const SIZE_LIST = [
    {
        id: 'S',
        value: 'S',
    },
    {
        id: 'M',
        value: 'M',
    },
    {
        id: 'L',
        value: 'L',
    },
]

export const DEFINED_IMAGE_LIST = [
    {
        name: 'face-smiling',
        title: '1. Gesichtsaufnahme (lachend) / Face front (smiling)',
        defaultImage: faceSmiling,
        shortTitle: 'Face (Smile)',
    },
    {
        name: 'face',
        title: '2. Gesichtsaufnahme (ohne Lachen) / Face front (not smiling)',
        defaultImage: face,
        shortTitle: 'Face (Not Smiling)',
    },
    {
        name: 'profile',
        title: '3. Gesichtsprofil (ohne Lachen) / Facial profile (not smiling)',
        defaultImage: profile,
        shortTitle: 'Profile',
    },
    {
        name: 'right-side',
        title:
            '4. Rechte Seitenaufnahme (mit Lippenspreizer) / Right side view (with lip spreader)',
        defaultImage: rightSide,
        shortTitle: 'Right bite',
    },
    {
        name: 'frontal',
        title:
            '5. Frontalaufnahme (mit Lippenspreizer) / Frontal shot (with lip spreader)',
        defaultImage: frontal,
        shortTitle: 'Front bite',
    },
    {
        name: 'left-side',
        title:
            '6. Linke Seitenaufnahme (mit Lippenspreizer)/ Left side view (with lip spreader)',
        defaultImage: leftSide,
        shortTitle: 'Left bite',
    },
    {
        name: 'upper-tooth-sector',
        title:
            '7. Oberer Zahnbogen (mit Lippenspreizer) / Upper dental arch (with lip spreader)',
        defaultImage: upperToothSector,
        shortTitle: 'Upper',
    },
    {
        name: 'bottom-tooth-sector',
        title:
            '8. Unterer Zahnbogen (mit Lippenspreizer) / Lower dental arch (with lip spreader)',
        defaultImage: bottomToothSector,
        shortTitle: 'Lower',
    },
    {
        name: 'lower-row-of-teeth',
        title: '9. Untere Zahnreihe / Lower row of teeth',
        shortTitle: 'Untere Zahnreihe',
    },
    {
        name: 'upper-row-with-aligner',
        title:
            '10. Oberer Zahnbogen (mit Zahnschiene) / Upper row (with aligner)',
        shortTitle: 'Oberer Zahnbogen (mit Zahnschiene)',
    },
    {
        name: 'lower-row-with-aligner',
        title:
            '11. Unterer Zahbogen (mit Zahnschiene) / Lower row (with aligner)',
        shortTitle: 'Unterer Zahbogen (mit Zahnschiene)',
    },
    {
        name: 'other',
        title: '12. Other ',
        defaultImage: optionalPhoto,
        shortTitle: 'Other',
    },
];

export const DEFINED_PRE_CHECKIN_IMAGE_LIST = [
    {
        name: 'face-smiling',
        title: '1. Porträt (lächelnd) / Portrait (smiling)',
        defaultImage: faceSmiling,
        shortTitle: 'Portrait (smiling)',
    },
    {
        name: 'face',
        title: '2. Porträt (nicht lachend) / Portrait (not smiling)',
        defaultImage: face,
        shortTitle: 'Portrait (not smiling)',
    },
    {
        name: 'profile',
        title: '3. Seitliches Profil / Side Profile',
        defaultImage: profile,
        shortTitle: 'Side Profile',
    },
    {
        name: 'right-side',
        title: '4. Rechter Biss / Right Bite',
        defaultImage: rightSide,
        shortTitle: 'Right bite',
    },
    {
        name: 'frontal',
        title: '5. Vorderzähne / Front Teeth',
        defaultImage: frontal,
        shortTitle: 'Front Teeth',
    },
    {
        name: 'left-side',
        title: '6. Linker Biss / Left Bite',
        defaultImage: leftSide,
        shortTitle: 'Left bite',
    },
    {
        name: 'upper-tooth-sector',
        title: '7. Obere Zähne / Upper Teeth',
        defaultImage: upperToothSector,
        shortTitle: 'Upper',
    },
    {
        name: 'bottom-tooth-sector',
        title: '8. Untere Zähne / Lower Teeth',
        defaultImage: bottomToothSector,
        shortTitle: 'Lower',
    },
    {
        name: 'upper-row-with-aligner',
        title: '9. Oberkiefer mit Zahnschiene / Upper Jaw with Aligner',
        shortTitle: 'Upper Jaw with Aligner',
    },
    {
        name: 'lower-row-with-aligner',
        title: '10. Unterkiefer mit Zahnschiene / Lower Jaw with Aligner',
        shortTitle: 'Lower Jaw with Aligner',
    },
    {
        name: 'other',
        title: '11. Andere / Other ',
        defaultImage: optionalPhoto,
        shortTitle: 'Other',
    },
];

export const IMAGE_TYPE_SELECT = DEFINED_IMAGE_LIST.map(image => ({
    id: image.name,
    value: image.title,
}))

export const PRE_CHECKIN_IMAGE_TYPE_SELECT = DEFINED_PRE_CHECKIN_IMAGE_LIST.map(image => ({
    id: image.name,
    value: image.title,
}))

export const TAB_BASIC_DATA = 'basic_data'
export const TAB_ACCOUNTING = 'accounting'
export const TAB_PHOTOS = 'photos'
export const TAB_FILES = 'files'
export const TAB_MEDICAL = 'medical'
export const TAB_COMMENTS = 'comments'



// WEBPACK FOOTER //
// ./src/modules/customer/state/detail/const.js